import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['minute', 'hour', 'minuteDisplay', 'hourDisplay']

  empty (e) {
    e.target.value = ''
  }

  updateHourMobile (e) {
    const hour = e.target.value
    this.hour = hour
  }

  updateMinuteMobile (e) {
    const minute = e.target.value
    this.minute = minute
  }

  updateHour (e) {
    const value = e.target.value

    if (Number(value) > 23) {
      e.target.value = null
      return
    }

    this.hour = value
    if (value.length === 2) this.minuteDisplayTarget.focus()
  }

  updateMinute (e) {
    const value = e.target.value

    if (Number(value) > 59) {
      e.target.value = null
      return
    }

    this.minute = value
    if (value.length === 2) this.minuteDisplayTarget.blur()
  }

  skipSelection () {
    this.hourTarget.value = null
    this.minuteTarget.value = null
  }

  set hour (value) {
    this.hourTarget.value = value.padStart(2, '0')
  }

  set minute (value) {
    this.minuteTarget.value = value.padStart(2, '0')
  }
}
